import React from "react";
import Card from "./Card";

const OrderTypeDescription = () => {
  return (
    <section className="bg-white border-t py-8">
      <div className="container mx-auto flex flex-wrap pt-4 pb-12">
        <h2 className="w-full my-2 text-3xl font-bold leading-tight text-center text-gray-800">
          Funktionen
        </h2>
        <div className="w-full mb-4">
          <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t" />
        </div>
        <div className="md:w-1/2 lg:w-1/5 p-6 flex flex-col flex-grow flex-shrink">
          <Card
            title="Tischservice"
            text="Mit dem Smartphone am Tisch bestellen und bezahlen. Einfach
              schnell und ohne auf die Speisekarte oder Servicekraft zu warten."
            textAlign="left"
            imgSrc={require("./../images/order_type/dinein.svg")}
          />
        </div>
        <div className="md:w-1/2 lg:w-1/5 p-6 flex flex-col flex-grow flex-shrink">
          <Card
            title="Take-Away"
            text="Auf dem Weg zum Lokal oder vom Büro aus vorbestellen und ohne
              Anstehen einfach abholen."
            textAlign="left"
            imgSrc={require("./../images/order_type/takeaway.svg")}
          />
        </div>
        <div className="md:w-1/3 lg:w-1/5 p-6 flex flex-col flex-grow flex-shrink">
          <Card
            title="Lieferung"
            text="Einfach von Zuhause oder dem Büro aus vorbestellen und an die angegebene Adresse liefern lassen."
            textAlign="left"
            imgSrc={require("./../images/order_type/delivery.svg")}
            highlight={true}
          />
        </div>
        <div className="md:w-1/3 lg:w-1/5 p-6 flex flex-col flex-grow flex-shrink">
          <Card
            title="Drive-In"
            text="Take-Away bei dem die Speisen vor Ort direkt zum Auto gebracht
              werden."
            textAlign="left"
            imgSrc={require("./../images/order_type/drivein.svg")}
          />
        </div>
        <div className="md:w-1/3 lg:w-1/5 p-6 flex flex-col flex-grow flex-shrink">
          <Card
            title="Vorbestellen & Reservieren"
            text="Von Zuhause oder dem Büro aus Tisch reservieren und gleich
              gewünschte Speisen & Getränke mit vorbestellen."
            textAlign="left"
            imgSrc={require("./../images/order_type/reservation.svg")}
          />
        </div>
      </div>
    </section>
  );
};

export default OrderTypeDescription;
